import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const CPTCodes = withLazyFallback(
  () => import('components/admin/pages/Databank/CPTCodes/CPTCodes')
);
const CDTCodes = withLazyFallback(
  () => import('components/admin/pages/Databank/CDTCodes/CDTCodes')
);
const DatabankDashboard = withLazyFallback(
  () => import('components/admin/pages/Databank/Dashboard')
);
const DatapointsTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Datapoints/DatapointsTable')
);
const GrowthDataTable = withLazyFallback(
  () => import('components/admin/pages/Databank/GrowthData/GrowthDataTable')
);
const ICD10Codes = withLazyFallback(
  () => import('components/admin/pages/Databank/ICD10Codes/ICD10Codes')
);
const Landmarks = withLazyFallback(
  () => import('components/admin/pages/Databank/Landmarks/Landmarks')
);
const ModifiersTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Modifiers/ModifiersTable')
);
const OccupationsTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Occupations/OccupationsTable')
);
const SpecialtyTable = withLazyFallback(
  () => import('components/admin/pages/Databank/Specialty/SpecialtyTable')
);

const ADMIN_DATABANK = [
  {
    path: 'databank',
    element: <DatabankDashboard />,
    handle: { title: 'Databank' },
    children: [
      { path: ':type', element: <DatapointsTable /> },
      { path: 'cpt-codes', element: <CPTCodes />, handle: { title: 'CPT Codes' } },
      { path: 'cdt-codes', element: <CDTCodes />, handle: { title: 'CDT Codes' } },
      { path: 'icd10-codes', element: <ICD10Codes />, handle: { title: 'ICD-10 Codes' } },
      { path: 'occupations', element: <OccupationsTable />, handle: { title: 'Occupations' } },
      { path: 'growth_data', element: <GrowthDataTable />, handle: { title: 'Growth Data' } },
      { path: 'landmarks', element: <Landmarks />, handle: { title: 'Landmarks' } },
      { path: 'specialities', element: <SpecialtyTable />, handle: { title: 'Specialties' } },
      { path: 'modifiers', element: <ModifiersTable />, handle: { title: 'Modifiers' } },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default ADMIN_DATABANK;
